var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._t("header"),_c('Spacer',{attrs:{"height":"","size":"l"}}),_c('div',{staticClass:"card-content"},[_vm._t("content")],2),_c('Spacer',{attrs:{"height":"","size":"xl"}}),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }